import React, { useState } from 'react';

/**
 * 1.解决KRN手势和容器手势冲突组件， 只能解决KRN和容器的冲突，KRN内部的手势冲突无法解决
 * 2.SPA项目的右滑手势冲突，请使用 SpaHorizontalGestureConflictView 组件
 * @param props.canScrollLeft 是否允许子组件左滑，即禁用容器左滑
 * @param props.canScrollRight 是否允许子组件右滑，即禁用容器右滑
 * @param props.canScrollTop 是否允许子组件上滑，即禁用容器上滑
 * @param props.canScrollBottom 是否允许子组件下滑，即禁用容器下滑
 */
export function GestureConflictHandleView(props: {
    // 是否允许子组件左滑，即禁用容器左滑
    canScrollLeft?: boolean;
    // 是否允许子组件右滑，即禁用容器右滑
    canScrollRight?: boolean;
    // 是否允许子组件上滑，即禁用容器上滑
    canScrollTop?: boolean;
    // 是否允许子组件下滑，即禁用容器下滑
    canScrollBottom?: boolean;
    children: any;
}) {
    return props.children;
}
